import type { Core } from 'chessboard/core/config/types';
import type { Plugins } from 'chessboard/core/plugins/config/types';

/**
 * Run beforeState hooks for a plugin to determine whether or not to update the state.
 */
export function runBeforeState(plugin: Plugins.Model, params: [Core.Event, Core.Context]): boolean {
  if (!plugin.beforeState) {
    return true;
  }

  let shouldUpdateState = true;

  plugin.beforeState.forEach((match: Plugins.BeforeState) => {
    if (run(match, params) === false) {
      shouldUpdateState = false;
    }
  });

  return shouldUpdateState;
}

/**
 * Attempt to run the hook
 */
function run(match: Plugins.BeforeState, matchParams: [Core.Event, Core.Context]): boolean | void {
  if (!match.condition(...matchParams)) {
    return;
  }

  return match.handler(...matchParams);
}
